import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { FloatingPanel } from '@/components/ui/FloatingPanel';
import { ViewToggle } from '@/components/ui/ViewToggle';
import { TopBarActions } from '../TopBar/TopBarActions';
import styles from './FloatingNavBar.module.css';

export const FloatingNavBar = memo(function FloatingNavBar() {
  const { t } = useTranslation();

  return (
    <FloatingPanel
      position="top-right"
      aria-label={t('appShell.floatingNav.label')}
      className={styles.elevated}
    >
      <div className={styles.floatingNavContent}>
        {/* ViewToggle auto-detects active artifact from URL and
            filters visible modes accordingly. */}
        <ViewToggle />
        <div className={styles.viewToggleDivider} />
        <TopBarActions variant="compact" />
      </div>
    </FloatingPanel>
  );
});
